const isZarazConsentReady = () => window.zaraz && window.zaraz.consent && window.zaraz.consent.APIReady
const updateZarazConsent = () => {
    const {MARKETING, PERSONALIZATION, ANALYTICS} = Osano.cm.getConsent()
    // Note - Personalisation is not in use yet and Zaraz will break if we attempt to set consent on an unused purpose
    zaraz.consent.set({
        'WpVs': MARKETING === 'ACCEPT',
        'mYqB': ANALYTICS === 'ACCEPT',
        // 'uYlg': PERSONALIZATION === 'ACCEPT',
    })
    zaraz.consent.sendQueuedEvents()
    zaraz.set("google_consent_update", {
        'ad_storage': MARKETING === 'ACCEPT' ? 'granted' : 'denied',
        'ad_user_data': MARKETING === 'ACCEPT' ? 'granted' : 'denied',
        'ad_personalization': PERSONALIZATION === 'ACCEPT' ? 'granted' : 'denied',
        'analytics_storage': ANALYTICS === 'ACCEPT' ? 'granted' : 'denied',
    })
}

if (isZarazConsentReady()) {
    updateZarazConsent()
}
else {
    document.addEventListener('zarazConsentAPIReady', updateZarazConsent)
}

if ('Osano' in window) {
    Osano.cm.addEventListener('osano-cm-consent-changed', () => {
        if (!isZarazConsentReady()) {
            return
        }
        updateZarazConsent()
    })
}
